import React, { useState, useEffect, Fragment } from "react"
import { Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Grid, Tooltip, } from "@material-ui/core"
import InfoIcon from '@material-ui/icons/Info';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { useSnackbar } from 'notistack';
import { checkApiStatus, format_Commas, validationMess } from "../../../../utils";
import { regexConstants } from "../../../../constants/regEx"
import { specificKey } from "../../../../constants"
import { trackActivity } from "../../../../utils/mixpanel";
import { globalGetService } from "../../../../utils/globalApiServices";
import { AutocompleteCreatable, PageLoader } from "../../../../shared_elements";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";

const EngineModuleForm = ({ match, props, modalCloseFn, modeType, engModuleData, getResponseBack }) => {
	const [error, setError] = useState({})
	const [data, setData] = useState(engModuleData ? engModuleData : {})
	const [pndata, setPndata] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	useEffect(() => {
		trackActivity('Engine Module  ADD Modal Opened - CAMO', {
			event_type: 'Modal Opened',
			page_title: 'Engine Module Add Task Form',
		})
		getPnDropdown()
	}, [])

	const onFieldChange = (keyParam, value) => {
		setData(prev => ({ ...prev, [keyParam]: value }))
	}

	const onResetErrorKey = (keyParam) => {
		setError(prev => ({ ...prev, [keyParam]: '' }))
	}

	const getPnDropdown = () => {
		globalGetService(`camo/engine_module_dropdown/?asset_id=${match?.params?.asset}`)
			.then(response => {
				if (checkApiStatus(response)) {
					setPndata(response?.data?.data || [])
				}
			})
	}

	const isFormValid = (validationInputs) => Object.values(validationInputs).every(v => v === '')

	const handleFormSubmit = (e) => {
		e.preventDefault()
		let validationInputs = {}
		validationInputs = {
			...validationInputs,
			module_name: data?.module_name ? '' : "Please add Module Name",
			section: data?.section?.trim() ? '' : "Please enter Section Name",
			tsn: error?.tsn || '',
			csn: error?.csn || '',
			tspr: error?.tspr || '',
			cspr: error?.cspr || '',
		}
		if (!isFormValid(validationInputs)) {
			setError(validationInputs)
			trackActivity(`Engine Module Data ${modeType === 'add' ? 'Added' : 'Updated'} Failed - CAMO`, {
				event_type: modeType === 'add' ? 'Add TASK Failed' : 'Update Data Failed',
				page_title: 'Engine Module',
				error_source: 'Frontend',
				error_type: validationInputs,
			})
			return
		}
		setIsLoading(true)
		let payload = Object.assign({}, data)
		payload = {
			...payload,
			asset_id: match.params.asset,
			asset_type_id: match.params.assetType,
			module_name: data?.module_name ? (data?.module_name?.name || data?.module_name) : null,
			tsn: data?.tsn || null,
			csn: data?.csn || null,
			tspr: data?.tspr || null,
			cspr: data?.cspr || null,
		}
		if (data?.id) {
			globalPutService(`camo/engine_module/${data?.id}/`, payload).then((response) => {
				if (checkApiStatus(response)) {
					modalCloseFn()
					getResponseBack()
					setIsLoading(false)
					enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				} else {
					setIsLoading(false)
					enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				}
			});
		} else {
			globalPostService(`camo/engine_module/`, payload).then((response) => {
				if (checkApiStatus(response)) {
					modalCloseFn()
					getResponseBack()
					setIsLoading(false)
					enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				} else {
					setIsLoading(false)
					enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
				}
			});

		}
	}

	// Handles TSN / TSPR — decimal fields (0 to 99999.99 or specific keywords)
	const handleDecimalChange = (key, label) => (e) => {
		const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '')
		const numericValue = value.replace(/[^\d.]/g, '')
		const dotCount = (numericValue.match(/\./g) || []).length
		const isValid = dotCount
			? numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)
			: value.length <= 5 && regexConstants.numberWithDot.test(numericValue)

		if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
			onFieldChange(key, e.target.value)
			setError(prev => ({
				...prev,
				[key]: e.target.value ? (!specificKey.includes(e.target.value.toUpperCase()) && validationMess(label, true)) : '',
			}))
		} else if (isValid || value === "") {
			onFieldChange(key, numericValue)
			setError(prev => ({ ...prev, [key]: '' }))
		}
	}
	// Handles CSN / CSPR — integer fields (0 to 99999 or specific keywords)
	const handleIntegerChange = (key, label) => (e) => {
		if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
			onFieldChange(key, e.target.value)
			setError(prev => ({
				...prev,
				[key]: e.target.value ? (!specificKey.includes(e.target.value.toUpperCase()) && validationMess(label, false)) : '',
			}))
		} else {
			if (e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "")) {
				onFieldChange(key, e.target.value.replace(/,/g, ''))
			}
			onResetErrorKey(key)
		}
	}
	const moduleNameOptions = pndata
		?.filter(item => item?.module_name)
		.map(pn => ({ id: pn?.id, name: pn.module_name })) || []

	const optionValue = data?.module_name
		? moduleNameOptions?.find(pn => pn.name === data?.module_name) || { module_name: data?.module_name }
		: null
	return (
		<Fragment>
			{isLoading ? <PageLoader /> : null}
			<section id="AmpTaskForm">
				<Dialog
					open={true}
					// className='fleet-template-modal'
					maxWidth='sm'
				>
					<DialogTitle>{data?.id ? "Update Engine Module" : "Add Engine Module"}</DialogTitle>
					<DialogContent dividers>
						<Grid spacing={2} container>
							<Grid item xs={12} md={6} sm={6}>
								<AutocompleteCreatable
									options={moduleNameOptions}
									paramsKey='module_name'
									optionKey='name'
									margin={"noMargin"}
									fullWidth
									value={optionValue?.name || optionValue?.module_name || ''}
									multiple={false}
									onFieldChange={(e, paramsKey, newValue) => {
										onFieldChange('module_name', newValue?.id ? newValue : newValue?.value)
										onResetErrorKey("module_name")
									}}
									label="Module Name"
									variant="outlined"
									required={true}
									error={error?.module_name}
									helperText={error?.module_name}
								/>
							</Grid>
							<Grid item xs={12} md={6} sm={6}>
								<TextField
									required
									variant="outlined"
									label="Section"
									id="section"
									fullWidth
									InputLabelProps={{ shrink: true }}
									value={data.section}
									error={!!error.section}
									helperText={error.section || ""}
									inputProps={{ maxLength: 50 }}
									onChange={(e) => { onFieldChange('section', e.target.value); onResetErrorKey("section") }}
								/>
							</Grid>
							<Grid item xs={12} sm={12} md={12}>
								<TextField
									variant="outlined"
									label="Description"
									name="description"
									id="description"
									fullWidth
									InputLabelProps={{ shrink: true }}
									value={data.description || ''}
									error={!!error.description}
									inputProps={{ maxLength: 255 }}
									helperText={error.description || ""}
									onChange={(e) => { onFieldChange('description', e.target.value); onResetErrorKey("part_number") }}
								/>
							</Grid>
							<Grid item xs={12} md={3} sm={6}>
								<TextField
									variant="outlined"
									fullWidth

									label={
										<span style={{ verticalAlign: 'super' }}>
											TSN
											<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
												<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
											</Tooltip>
										</span>
									}
									name="tsn"
									id="tsn"
									error={!!error.tsn}
									helperText={error.tsn || ""}
									value={regexConstants.alphanumespcespclchar.test(data.tsn) ? data.tsn : format_Commas(data?.tsn?.replace(/[^0-9.]/g, ''))}
									inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tsn) && 10 }}
									InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
									onChange={handleDecimalChange('tsn', 'TSN')}
								/>
							</Grid>
							<Grid item xs={12} md={3} sm={6}>
								<TextField
									variant="outlined"
									fullWidth
									label={
										<span style={{ verticalAlign: 'super' }}>
											CSN
											<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
												<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
											</Tooltip>
										</span>
									}
									name="csn"
									id="csn"
									InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
									error={!!error.csn}
									helperText={error.csn || ""}
									inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.csn) && 9 }}
									value={regexConstants.alphanumespcespclchar.test(data.csn) ? data.csn : format_Commas(data?.csn?.toString().replace(/[^0-9.]/g, ''))}
									onChange={handleIntegerChange('csn', 'CSN')}
								/>
							</Grid>
							<Grid item xs={12} md={3} sm={6}>
								<TextField
									fullWidth
									required={!!data.installation_date}
									variant="outlined"
									name="tspr"
									id="tspr"
									label={
										<span style={{ verticalAlign: 'super' }}>
											TSPR
											<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
												<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
											</Tooltip>
										</span>
									}
									error={!!error.tspr}
									helperText={error.tspr || ""}
									value={regexConstants.alphanumespcespclchar.test(data.tspr) ? data.tspr : format_Commas(data?.tspr?.replace(/[^0-9.]/g, ''))}
									inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tspr) && 10 }}
									InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
									onChange={handleDecimalChange('tspr', 'TSPR')}
								/>
							</Grid>
							<Grid item xs={12} md={3} sm={6}>
								<TextField
									required={!!data.installation_date}
									variant="outlined"

									fullWidth
									label={
										<span style={{ verticalAlign: 'super' }}>
											CSPR
											<Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
												<InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
											</Tooltip>
										</span>
									}
									name="cspr"
									id="cspr"
									InputLabelProps={{ shrink: true }}
									inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.cspr) && 9 }}
									error={!!error.cspr}
									helperText={error.cspr || ""}
									value={regexConstants.alphanumespcespclchar.test(data.cspr) ? data.cspr : format_Commas(data?.cspr?.toString().replace(/[^0-9.]/g, ''))}
									onChange={handleIntegerChange('cspr', 'CSPR')}
								/>
							</Grid>
						</Grid>
						<Grid item xs={12} md={12} sm={12}>
							<TextField
								label="Remarks"
								margin='normal'
								variant='outlined'
								fullWidth
								value={data.remarks}
								InputLabelProps={{ shrink: true }}
								onChange={(e) => onFieldChange("remarks", e.target.value)}
								rows={2}
								multiline
								inputProps={{ maxLength: 255 }}
							/>
						</Grid>
					</DialogContent>
					<DialogActions className="actions-btn">
						<Button type="button" className="btn btn-primary" disabled={isLoading} onClick={handleFormSubmit} > {modeType === "add" ? "SAVE" : "UPDATE"} </Button>
						<Button type="button" className="btn btn-primary" onClick={modalCloseFn}>CLOSE</Button>
					</DialogActions>
				</Dialog>
			</section>
		</Fragment>
	)
}

export default withRouter(EngineModuleForm)